import * as React from "react";
import { DeviceData } from "../models/DeviceData";
import Modal from "react-bootstrap/Modal";
import { DeviceMenuProps } from "../models/deviceMenuProps";

interface Props {
    closeModal: () => void;
    onCopyClicked: (device: DeviceData) => void
    onDeleteClicked: (device: DeviceData) => Promise<void>
    deviceMenuProps: DeviceMenuProps;
}

const DeviceMenuItems = (props: Props) => {
    const menuProps = props.deviceMenuProps;

  if (props.deviceMenuProps?.actions.length > 0) {
    return (
      <Modal
        show={true}
        size="sm"
        animation={false}
        onEscapeKeyDown={() => props.closeModal()}
        onHide={() => props.closeModal()}
      >
        <div className="device_menuItems" style={{ position: "fixed", display: 'block', top: `${menuProps.top}px`, left: `${menuProps.left}px` }}>
          {props.deviceMenuProps.actions &&
            props.deviceMenuProps.actions.map((action, i) => {
              return (
                <div key={i} onClick={() => action.do()}>
                  <span>{action.name}</span>
                </div>
              )
            })}
        </div>
      </Modal>
    );
  }
  else {
    return null;
  }
}

export default DeviceMenuItems;